import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { showErrorInNotification, schema_to_field, copyStringToClipboard } from '../../../lib/util';
import { BasicHeader } from '../../../components/basic_header';
import { Select, Result, Button, Row, message, Input, Divider, Steps, Tabs } from 'antd';
import Title from 'antd/lib/typography/Title';
import Form from '../../../lib/ui/form';
import { Link } from 'react-router-dom';
import { ExpandLessOutlined, ExpandMoreOutlined, Cancel } from '@material-ui/icons';
import Paragraph from 'antd/lib/typography/Paragraph';
import Text from 'antd/lib/typography/Text';
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';

import ace from 'brace';
import 'brace/mode/json';
import 'brace/theme/tomorrow_night_blue';


const normalizer = [
    { index: 'amount', name: 'Amount', type: 'text', required: true },
    { index: 'description', name: 'Description', type: 'text', required: true },
    { index: 'source_id', name: 'Source ID', type: 'text', required: true },
    { index: 'transaction_id', name: 'Transaction ID', type: 'text' },
    { index: 'txn_date', name: 'Transaction Date', type: 'text', required: true },
    { index: 'type', name: 'Type', type: 'text', required: true },
    { index: 'reconcile', name: 'Reconcile Expression', type: 'text', required: true }
]

const balance_normalizer = [
    { index: 'opening_balance', name: "Opening Balance", type: 'text' },
    { index: 'closing_balance', name: "Closing Balance", type: 'text' }
]

const SUCCESS_STEPS = 5;
const ERROR_STEPS = 6;


class RepositorySelectorAdd extends Component {
    constructor(props) {
        super(props)

        this.repository_id = props.match.params.repository_id;
        this.state = {
            selector_name: props.edit_data && props.edit_data.name,
            selector_data: this.props.edit_data || {},
            steps: 0,
            parsers: {},
            parserSchema: [],
            datatypes: {},
            blocks_schema: [],
            error_section: [],
            reference_normalizer: {},
            reference_parser: {},
            selectors: {},
            selectorSchema: [],
            edit_id: props.edit_id,
        }

        this.post_selector = RESTExecutor.post().config({
            label: 'selectors'
        }).callbacks((success) => {
            message.success("Selector Added Successfully");
            this.setState({
                steps: SUCCESS_STEPS
            })
        }, (error) => {
            let error_section = [];
            showErrorInNotification(error);

            // console.log(Object.keys("dasdasd"))
            console.log("ERROR IS", error)
            if (error.validation_errors && typeof error.validation_errors === 'object' && Object.keys(error.validation_errors)) {
                console.log("error is obj")
                error_section.push(<Paragraph>
                    <Text
                        strong
                        style={{
                            fontSize: 16,
                        }}
                    >
                        The content you submitted has the following error:
                    </Text>

                </Paragraph>)
                Object.keys(error.validation_errors).map((key, index) => {
                    let error_item = error.validation_errors[key];
                    if (typeof error_item === 'string') {
                        error_section.push(
                            <Paragraph>
                                <Cancel style={{ color: 'red' }} type="close-circle" /> {error_item}
                            </Paragraph>
                        )
                    }
                    else if (Array.isArray(error_item)) {
                        error_section.push(
                            <Paragraph>
                                <Cancel style={{ color: 'red' }} type="close-circle" /> {error_item[0]}
                            </Paragraph>
                        )
                    }
                })
            } else if (typeof error.error_message === 'string') {
                error_section.push(<Paragraph>
                    <Cancel style={{ color: 'red' }} type="close-circle" /> {error.error_message}
                </Paragraph>)
            }

            this.setState({
                steps: ERROR_STEPS,
                error_section: error_section
            })
        }).connect(props.domains.datarepository);

        this.patch_selector = RESTExecutor.patch().config({
            label: 'selectors_detail',
            params: {
                repository_id: "",
                selector_id: ""
            }
        }).callbacks((success) => {
            message.success("Selector Edited Successfully");
            this.setState({
                steps: SUCCESS_STEPS,
            })
            // typeof this.props.onCloseReload==='function'&&this.props.onCloseReload()
        }, (error) => {
            let error_section = [];
            showErrorInNotification(error);

            // console.log(Object.keys("dasdasd"))
            console.log("ERROR IS", error)
            if (error.validation_errors && typeof error.validation_errors === 'object' && Object.keys(error.validation_errors)) {
                console.log("error is obj")
                error_section.push(<Paragraph>
                    <Text
                        strong
                        style={{
                            fontSize: 16,
                        }}
                    >
                        The content you submitted has the following error:
                    </Text>

                </Paragraph>)
                Object.keys(error.validation_errors).map((key, index) => {
                    let error_item = error.validation_errors[key];
                    if (typeof error_item === 'string') {
                        error_section.push(
                            <Paragraph>
                                <Cancel style={{ color: 'red' }} type="close-circle" /> {error_item}
                            </Paragraph>
                        )
                    }
                    else if (Array.isArray(error_item)) {
                        error_section.push(
                            <Paragraph>
                                <Cancel style={{ color: 'red' }} type="close-circle" /> {error_item[0]}
                            </Paragraph>
                        )
                    }
                })
            } else if (typeof error.error_message === 'string') {
                error_section.push(<Paragraph>
                    <Cancel style={{ color: 'red' }} type="close-circle" /> {error.error_message}
                </Paragraph>)
            }

            this.setState({
                steps: ERROR_STEPS,
                error_section: error_section
            })

        }).connect(props.domains.datarepository);


        this.list_selectors = RESTExecutor.list().config({
            label: 'selector_config'
        }).callbacks((success) => {
            let selectors = {};
            success.result.rows.map((item) => {
                selectors[item.id] = item
            });
            this.setState({
                selectors: selectors
            });

            if (this.props.edit_id) {

                this.setState({
                    selectorSchema: schema_to_field(selectors[this.props.edit_data.selector_id].validation_config || {})
                })
            }

        }).connect(props.domains.plugins);

        this.list_datatypes = RESTExecutor.list().config({
            url: '/selector-data-types',
            params: {
                pagination: false
            }
        }).callbacks((success)=>{
            let datatypes = {};
            success.result.rows.map((item) => {
                datatypes[`${item.id}`] = item
            });
            this.setState({
                datatypes: datatypes
            });
        },(error)=>{
            showErrorInNotification(error)
        }).connect(props.domains.datatype);


        // this.list_datatypes = fetch("http://192.168.101.11:8001/api/v1/selector-data-types")
        //         .then((response) => response.json())
        //         .then((data)=>{
        //             console.log(data.data.rows)
        //             let datatypes = {};
        //             data.data.rows.map((item) => {
        //                 datatypes[`${item.id}`] = item
        //             });
        //             this.setState({
        //                 datatypes: datatypes
        //             });
        //         })
        //         .catch((error)=>{
        //             showErrorInNotification(error)
        //         })
        //         // .then(RESTExecutor.connect(props.domains.datatype))
        


        this.list_references_parser = RESTExecutor.list().config({
            label: 'list',
            params: {
                type: "PARSER"
            }
        }).callbacks((success) => {
            let reference_parser = this.state.reference_parser;
            success.result.rows.map((item) => {
                reference_parser[item.id] = item;
            });
            this.setState({
                reference_parser: reference_parser
            });
        }, (error) => {
            showErrorInNotification(error);
        }).connect(props.domains.references);

        this.list_references_normalizer = RESTExecutor.list().config({
            label: 'list',
            params: {
                type: "NORMALIZER"
            }
        }).callbacks((success) => {
            let reference_normalizer = this.state.reference_normalizer;
            success.result.rows.map((item) => {
                reference_normalizer[item.id] = item;
            });
            this.setState({
                reference_normalizer: reference_normalizer
            });
        }, (error) => {
            showErrorInNotification(error);
        }).connect(props.domains.references);

        this.list_parsers = RESTExecutor.list().config({
            label: 'parsers'
        }).callbacks((success) => {
            var parsers = {};

            success.result.rows.map((item) => {
                parsers[item.id] = item
            });
            this.setState({
                parsers: parsers
            });
            if (this.props.edit_id) {

                this.setState({
                    parserSchema: schema_to_field(parsers[this.props.edit_data.parser_id].validation_config || {}),
                    blocks_schema: schema_to_field(parsers[this.props.edit_data.parser_id].blocks_config || {}),
                })
            }
        }, (error) => {

        }).connect(props.domains.plugins)


        this._renderStepsContent = this._renderStepsContent.bind(this);


    }
    componentDidMount() {
        this.list_datatypes.execute();
        this.list_parsers.execute();
        this.list_selectors.execute()
        // this.list_extensions.execute();
        this.list_references_normalizer.execute();
        this.list_references_parser.execute();
    }

    handlePostPatch = () => {
        if (this.state.edit_id) {
            this.patch_selector.config({
                params: {
                    repository_id: this.repository_id,
                    selector_id: this.props.edit_id
                }
            }).execute(this.state.selector_data)
        } else {
            this.post_selector.forId(this.repository_id).execute(this.state.selector_data);
        }
    }


    _renderStepsFooter = (currentStep) => {
        let post_selector_resp = this.post_selector.response();
        let patch_selector_resp = this.patch_selector.response();
        return <Row type='flex' justify='space-between' style={{
            paddingLeft: 8,
            paddingRight: 8,
            paddingTop: 20,
            paddingBottom: 20
        }}>
            <div>
                {currentStep !== 0 && <Button type='link' style={{ color: 'red' }}
                    onClick={() => {
                        this.setState({
                            steps: this.state.steps - 1
                        })
                    }}
                >Previous</Button>}
            </div>

            <div>
                {currentStep !== 3 && <Button type='primary'
                    onClick={() => {
                        this.setState({
                            steps: this.state.steps + 1
                        })
                    }}
                >Next</Button>}
                {currentStep === 3 && <Button
                    disabled={post_selector_resp.fetching || patch_selector_resp.fetching}
                    loading={post_selector_resp.fetching || patch_selector_resp.fetching}
                    type='primary'
                    onClick={() => {
                        this.handlePostPatch()
                    }}
                >Submit</Button>}

            </div>
        </Row>
    }


    _renderStepsContent = ({ step, activeIndex }) => {
        // if (step != activeIndex) {
        //     return ""
        // }

        let selector_data = this.state.selector_data;
        let parser_resp = this.list_parsers.response();
        let list_datatypes_resp = this.list_datatypes.response();
        let datatype_list = (list_datatypes_resp.result && list_datatypes_resp.result.rows) || [];
        // let list_extension_resp = this.list_extensions.response();
        // let list_extensions_data = list_extension_resp.result || {};
        // let extensions_list = list_extensions_data.rows || [];


        switch (step) {
            case 0:
                return <div><Row type='flex' justify='center'>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: 'fit-content',
                        textAlign: 'right'
                    }}
                    >
                        <span>Name: &nbsp; <Input
                            placeholder={"Name"}
                            onChange={(e) => {
                                this.stateUpdater({ stateKey: 'selector_data', valueKey: 'name', value: e.target.value })
                            }}
                            value={selector_data.name}
                            style={{
                                width: 300,
                                marginBottom: 12
                            }} >
                        </Input>
                        </span>
                        <span>DataType: <Select style={{ width: 300, marginBottom: 12 }}
                            placeholder="Datatype"
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            showSearch
                            value={selector_data.data_type_id}
                            onChange={(value) => {
                                this.stateUpdater({
                                    stateKey: 'selector_data', valueKey: 'data_type_id', value: value
                                });
                            }}
                        >
                            {
                                datatype_list.map((item, index) => {
                                    // let item = selectors[key];
                                    return <Select.Option value={`${item.id}`} key={`${item.id}`}>
                                        {item.name}
                                    </Select.Option>
                                })
                            }
                        </Select>
                        </span>
                    </div>

                </Row>
                    {this._renderStepsFooter(step)}
                </div>
            case 2:
                return <div>
                    <Row type='flex' justify='center'>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: 'fit-content',
                            textAlign: 'right'
                        }}
                        >
                            <span>Parser: &nbsp; <Select placeholder={"Parser"} style={{
                                width: 300
                            }}
                                value={selector_data.parser_id}
                                showSearch
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                loading={parser_resp.fetching}
                                onChange={(value) => {
                                    console.log("parser id", value, this.state.parsers[value]);
                                    this.stateUpdater({ stateKey: 'selector_data', valueKey: 'parser_id', value: value })
                                    this.setState({
                                        parserSchema: schema_to_field(this.state.parsers[value].validation_config),
                                        blocks_schema: schema_to_field(this.state.parsers[value].blocks_config),
                                    })
                                }}
                            >
                                {Object.keys(this.state.parsers).map((key, index) => {

                                    let dataItem = this.state.parsers[key] || {}
                                    return <Select.Option value={dataItem.id} key={dataItem.id}>
                                        {dataItem.name}
                                    </Select.Option>
                                })}
                            </Select>
                            </span>
                        </div></Row>

                    {selector_data.parser_id ?
                        <div>
                            <div>
                                <center><Button style={{
                                    display: 'flex'
                                }} onClick={() => {
                                    this.setState({
                                        showReferencesParser: !this.state.showReferencesParser
                                    })
                                }} type='link' icon={this.state.showReferencesParser ? <ExpandLessOutlined /> : <ExpandMoreOutlined />}>{
                                        this.state.showReferencesParser ? "Hide Reference" : "Use Reference"
                                    }</Button></center>
                                {this.state.showReferencesParser &&
                                    <center> <span>Reference: &nbsp; <Select placeholder={"Reference"} style={{
                                        width: 300
                                    }}
                                        //   value={selector_data.parser_id}
                                        showSearch
                                        filterOption={(input, option) => {
                                            return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }}
                                        onSearch={(value) => {
                                            console.log(value)
                                            this.list_references_parser.config({
                                                params: {
                                                    type: "PARSER",
                                                    query: value
                                                }
                                            }).execute()
                                        }}
                                        onChange={(value) => {
                                            // console.log("parser id", value, this.state.parsers[value]);

                                            //   this.stateUpdater({ stateKey: 'selector_data', valueKey: 'parser_id', value: value })
                                            this.stateUpdater({
                                                stateKey: 'selector_data', valueKey: 'parse_config', value:
                                                    (this.state.reference_parser[value] && this.state.reference_parser[value].config) || {}
                                            })
                                        }}
                                    >
                                        {Object.keys(this.state.reference_parser).map((key, index) => {

                                            let dataItem = this.state.reference_parser[key] || {}
                                            return <Select.Option value={dataItem.id} key={dataItem.id}>
                                                {dataItem.name}
                                            </Select.Option>
                                        })}
                                    </Select>
                                    </span></center>}


                                <Row style={{
                                    padding: 4
                                }} type='flex' justify='space-between'>
                                    <Title style={{ margin: 0 }} level={4} type='secondary'>Parser Configs</Title>

                                    <Button size='small' type='primary' className='export-btn' onClick={() => {
                                        copyStringToClipboard(JSON.stringify(selector_data.parse_config || {}));
                                        message.success("Copied")
                                    }}>Copy To Clipboard</Button>
                                </Row>
                                <Form
                                    hideTitle
                                    forCreate={true}
                                    initialData={selector_data.parse_config || {}}
                                    submitted={this.state.submitted}
                                    onChange={(data) => {
                                        console.log("Changes", data);
                                        this.stateUpdater({
                                            stateKey: 'selector_data',
                                            valueKey: 'parse_config',
                                            value: data,
                                            // callback: () => {
                                            //     this.stateUpdater({
                                            //         stateKey: 'selector_data',
                                            //         valueKey: 'display_order',
                                            //         value: (selector_data.parse_config && selector_data.parse_config.config && Object.keys(selector_data.parse_config.config)) || []
                                            //     });
                                            // }

                                        })
                                    }}
                                    fields={this.state.parserSchema}
                                    submitting={{}}
                                    errorMessage={{}}
                                    validationErrors={{}}
                                />
                                {this.state.blocks_schema.length > 0 ? <React.Fragment>


                                    <Divider />
                                    <Title style={{ margin: 0 }} level={4} type='secondary'>Block Configs</Title>
                                    <Form
                                        hideTitle
                                        forCreate={true}
                                        initialData={selector_data.blocks_config || {}}
                                        submitted={this.state.submitted1}
                                        onChange={(data) => {
                                            console.log("Changes", data);
                                            this.stateUpdater({
                                                stateKey: 'selector_data',
                                                valueKey: 'blocks_config',
                                                value: data,
                                                // callback: () => {
                                                //     this.stateUpdater({
                                                //         stateKey: 'selector_data',
                                                //         valueKey: 'display_order',
                                                //         value: (selector_data.parse_config && selector_data.parse_config.config && Object.keys(selector_data.parse_config.config)) || []
                                                //     });
                                                // }

                                            })
                                        }}
                                        fields={this.state.blocks_schema}
                                        submitting={{}}
                                        errorMessage={{}}
                                        validationErrors={{}}
                                    />
                                </React.Fragment> : null}
                            </div>
                        </div>
                        : null}


                    {this._renderStepsFooter(step)}
                </div>

            case 1:
                return <div>
                    <Row type='flex' justify='center'>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: 'fit-content',
                            textAlign: 'right'
                        }}
                        >
                            <span>Selector: &nbsp; <Select placeholder={"Selector"} style={{
                                width: 300
                            }}
                                value={selector_data.selector_id}
                                showSearch
                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                loading={parser_resp.fetching}
                                onChange={(value) => {
                                    // console.log("selector_id ", value, this.state.parsers[value]);
                                    this.stateUpdater({ stateKey: 'selector_data', valueKey: 'selector_id', value: value })
                                    this.setState({
                                        selectorSchema: schema_to_field(this.state.selectors[value].validation_config),
                                    })
                                }}
                            >
                                {Object.keys(this.state.selectors).map((key, index) => {

                                    let dataItem = this.state.selectors[key] || {}
                                    return <Select.Option value={dataItem.id} key={dataItem.id}>
                                        {dataItem.name}
                                    </Select.Option>
                                })}
                            </Select>
                            </span>
                        </div></Row>

                    {selector_data.selector_id && this.state.selectorSchema.length > 0 ?
                        <div>
                            <div>
                                <Row style={{
                                    padding: 4
                                }} type='flex' justify='space-between'>
                                    <Title style={{ margin: 0 }} level={4} type='secondary'>Selector Configs</Title>

                                    {/* <Button size='small' type='primary' className='export-btn' onClick={() => {
                                    copyStringToClipboard(JSON.stringify(selector_data.sele || {}));
                                    message.success("Copied")
                                }}>Copy To Clipboard</Button> */}
                                </Row>
                                <Form
                                    hideTitle
                                    forCreate={true}
                                    initialData={selector_data.selector_config || {}}
                                    submitted={this.state.submitted}
                                    onChange={(data) => {
                                        console.log("Changes", data);
                                        this.stateUpdater({
                                            stateKey: 'selector_data',
                                            valueKey: 'selector_config',
                                            value: data,
                                            // callback: () => {
                                            //     this.stateUpdater({
                                            //         stateKey: 'selector_data',
                                            //         valueKey: 'display_order',
                                            //         value: (selector_data.parse_config && selector_data.parse_config.config && Object.keys(selector_data.parse_config.config)) || []
                                            //     });
                                            // }

                                        })
                                    }}
                                    fields={this.state.selectorSchema}
                                    submitting={{}}
                                    errorMessage={{}}
                                    validationErrors={{}}
                                />
                            </div>
                        </div>
                        : null}

                    <Divider />
                    <Title style={{ margin: 0 }} level={4} type='secondary'>Extra Values</Title>
                    {/* <span></span> */}
                    <div className='json-editor-wrapper large'>
                        <Editor
                            mode={Editor.modes.code}
                            value={selector_data.extra_values || {}}
                            onChange={(value) => {
                                console.log("change value is", value);
                                this.stateUpdater({ stateKey: 'selector_data', valueKey: 'extra_values', value: value })
                            }}
                            className='small-json-editor'
                            search={false}
                            navigationBar={false}
                            statusBar={false}
                            ace={ace}

                        /></div>



                    {this._renderStepsFooter(step)}
                </div>

            case 3:
                let formatted_normalizer = selector_data.normalizer_config || "";
                if (typeof selector_data.normalizer_config === 'object') {
                    formatted_normalizer = JSON.stringify(selector_data.normalizer_config, null, 4);
                }
                return <div>
                    <center><Button style={{
                        display: 'flex'
                    }} onClick={() => {
                        this.setState({
                            showReferencesNormalizer: !this.state.showReferencesNormalizer
                        })
                    }} type='link' icon={this.state.showReferencesNormalizer ? <ExpandLessOutlined /> : <ExpandMoreOutlined />}>{
                            this.state.showReferencesNormalizer ? "Hide Reference" : "Use Reference"
                        }</Button></center>
                    {this.state.showReferencesNormalizer &&
                        <center> <span>Reference: &nbsp; <Select placeholder={"Reference"} style={{
                            width: 300
                        }}
                            //   value={selector_data.parser_id}
                            showSearch
                            filterOption={(input, option) => {
                                return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }}
                            onSearch={(value) => {
                                console.log(value)
                                this.list_references_normalizer.config({
                                    params: {
                                        type: "NORMALIZER",
                                        query: value
                                    }
                                }).execute()
                            }}
                            onChange={(value) => {
                                // console.log("parser id", value, this.state.parsers[value]);

                                //   this.stateUpdater({ stateKey: 'selector_data', valueKey: 'parser_id', value: value })
                                this.stateUpdater({
                                    stateKey: 'selector_data', valueKey: 'normalizer_config', value:
                                        (this.state.reference_normalizer[value] && this.state.reference_normalizer[value].config) || {}
                                })
                            }}
                        >
                            {Object.keys(this.state.reference_normalizer).map((key, index) => {

                                let dataItem = this.state.reference_normalizer[key] || {}
                                return <Select.Option value={dataItem.id} key={dataItem.id}>
                                    {dataItem.name}
                                </Select.Option>
                            })}
                        </Select>
                        </span></center>}

                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                    }}>

                        <Row type='flex' justify='space-between'>
                            <Title level={4} >Normalizer Config</Title>
                            <Button size='small' type='primary' className='export-btn' onClick={() => {
                                copyStringToClipboard(JSON.stringify(selector_data.normalizer_config || {}));
                                message.success("Copied")
                            }}>Copy To Clipboard</Button>
                        </Row>
                        <Form
                            hideTitle
                            forCreate={true}
                            initialData={selector_data.normalizer_config || {}}
                            submitted={this.state.submitted}
                            onChange={(data) => {
                                console.log("Changes", data);
                                this.has_changed = true;
                                this.stateUpdater({
                                    stateKey: 'selector_data',
                                    valueKey: 'normalizer_config',
                                    value: data
                                })

                                //   this.setState({selector_data:data})
                            }}
                            fields={[...normalizer,
                            ...(selector_data.data_type_id && this.state.datatypes[selector_data.data_type_id]) ? schema_to_field(this.state.datatypes[selector_data.data_type_id].fields_config) : []
                            ]}
                            submitting={{}}
                            errorMessage={{}}
                            validationErrors={{}}
                        />
                        <br></br>
                        <Title level={4} >Balance Normalizer Config</Title>
                        <Form
                            hideTitle
                            forCreate={true}
                            initialData={selector_data.balance_normalizer_config || {}}
                            submitted={this.state.submitted}
                            onChange={(data) => {
                                console.log("Changes", data);
                                this.has_changed = true;
                                this.stateUpdater({
                                    stateKey: 'selector_data',
                                    valueKey: 'balance_normalizer_config',
                                    value: data
                                })

                                //   this.setState({selector_data:data})
                            }}
                            fields={balance_normalizer}
                            submitting={{}}
                            errorMessage={{}}
                            validationErrors={{}}
                        />
                    </div>
                    {/* <Divider /> */}
                    {/* <Input.TextArea
                      placeholder="Normalizer Config"
                      value={formatted_normalizer}
                      onChange={(e) => {

                          let d = e.target.value;
                          try {
                              d = JSON.parse(d);
                          } catch (e) {

                          }

                          this.stateUpdater({
                              stateKey: 'selector_data',
                              valueKey: 'normalizer_config',
                              value: d,
                          });
                      }}
                      rows={4} /> */}

                    {this._renderStepsFooter(step)}
                </div>


            default:
                return <div></div>
        }

        return <div></div>
    }


    stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
        let newData = this.state[stateKey];
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {
        const { steps, selector_data } = this.state;

        return (
            <div> <BasicHeader

                title={this.state.edit_id ? this.state.selector_name : `Selector Add`}
                subtitle={this.state.edit_id ? "Edit" : null}
            />
                <div className='default-card' style={{
                    padding: 16,
                    minHeight: 700,
                    display: 'flex',
                    flexDirection: 'column',
                    // justifyContent: 'space-between'
                }}>
                    <div>

                        {steps === SUCCESS_STEPS ? <div> <Result
                            status="success"
                            title="Successfully completed operation on Selector"
                            // subTitle=""
                            extra={[
                                <Link to={`/settings/data-repository/${this.repository_id}/selectors`}>
                                    <Button type='dashed' key="console">
                                        Go to Selectors
                                    </Button></Link>
                            ]}
                        />

                        </div> :
                            steps === ERROR_STEPS ?
                                <div> <Result

                                    status='error'
                                    title="Operation Failed"
                                    subTitle="Please check and modify the following information before resubmitting."
                                    // subTitle=""
                                    extra={[
                                        <Link to={`/settings/data-repository/${this.repository_id}/selectors`}>
                                            <Button type='dashed' key="console">
                                                Go to Selectors
                                            </Button></Link>,

                                        <Button key="try_again" type='primary' onClick={() => {
                                            this.setState({
                                                steps: 0
                                            })
                                        }}>Try Again</Button>,
                                    ]}
                                />
                                    <div className="desc" style={{
                                        textAlign: 'left'
                                    }}>
                                        {this.state.error_section}
                                    </div>

                                </div>
                                : <div>

                                    {/* <Tabs activeKey={`${steps}`}>
                                <Tabs.TabPane key={`0`} tab="Basic Detail">
                                {this._renderStepsContent({
                                        step: 0,
                                        activeIndex: steps
                                    })}
                                </Tabs.TabPane>
                                <Tabs.TabPane key={`1`} tab="Selector">
                                {this._renderStepsContent({
                                        step: 1,
                                        activeIndex: steps
                                    })}
                                </Tabs.TabPane>
                                <Tabs.TabPane key={`2`} tab="Parser">
                                {this._renderStepsContent({
                                        step: 2,
                                        activeIndex: steps
                                    })}
                                </Tabs.TabPane>
                                <Tabs.TabPane key={`3`} tab="Normalizer">
                                {this._renderStepsContent({
                                        step: 3,
                                        activeIndex: steps
                                    })}
                                </Tabs.TabPane>
                            </Tabs> */}

                                    <Steps
                                        onChange={(current) => {
                                            this.setState({
                                                steps: current
                                            })
                                        }}
                                        type='navigation' directions='vertical' current={steps} >
                                        <Steps.Step title="Basic Detail"
                                            descriptions={<div style={{
                                                padding: 8,
                                                paddingLeft: 20,
                                                paddingRight: 20
                                            }}>
                                                {this._renderStepsContent({
                                                    step: 0,
                                                    activeIndex: steps
                                                })}
                                            </div>}
                                        />
                                        <Steps.Step title="Selector"
                                            descriptions={<div style={{
                                                padding: 8,
                                                paddingLeft: 20,
                                                paddingRight: 20
                                            }}>
                                                {this._renderStepsContent({
                                                    step: 1,
                                                    activeIndex: steps
                                                })}
                                            </div>}
                                        />
                                        <Steps.Step title="Parser"
                                            descriptions={<div style={{
                                                padding: 8,
                                                paddingLeft: 20,
                                                paddingRight: 20
                                            }}>
                                                {this._renderStepsContent({
                                                    step: 2,
                                                    activeIndex: steps
                                                })}
                                            </div>}
                                        />

                                        <Steps.Step title="Normalizer"
                                            descriptions={<div style={{
                                                padding: 8,
                                                paddingLeft: 20,
                                                paddingRight: 20
                                            }}>
                                                {this._renderStepsContent({
                                                    step: 3,
                                                    activeIndex: steps
                                                })}
                                            </div>}
                                        />
                                    </Steps>
                                    <div style={{
                                        paddingTop: 40,
                                    }}>
                                        {this._renderStepsContent({
                                            // step: 3,
                                            step: steps
                                        })}
                                    </div>
                                    {/* <div style={{
                            paddingTop:20,
                        }}>{steps < 4 &&
                        <Row type='flex' justify='space-between'>
                            <div>
                                {steps === 0 ? <div></div> : <Button ghost type='danger'
                                    onClick={() => {
                                        this.setState({
                                            steps: steps - 1
                                        })
                                    }}
                                >Previous</Button>}
                            </div>
                            <Button type='primary' onClick={() => {
                                if (steps < 3) {
                                    this.setState({
                                        steps: steps + 1
                                    });
                                } else if (steps === 3) {
                                    this.handlePostPatch(selector_data);
                                }
                            }}>
                                {steps === 3 ? "Done" : "Next"}
                            </Button>

                        </Row>
                    }
                    </div> */}
                                </div>

                        }
                    </div>
                    <div>

                    </div>

                </div>
            </div>
        );
    }
}

export default withDomains(RepositorySelectorAdd, "plugins", "references", "datatype", "datarepository");
